import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import BottomModalRedeemUsing from '../common/bottom-modal-nojoom-redeem';
import GiftAnotherNumberModal from '../common/gift-another-number-modal';
import {RecordlogEvents} from '../../analytics/RecordEvents'
import { GetCacheKey } from '../../services/common/utils';
import { useQuery } from 'react-query';
const ServicesCard = ({ data }) => {
  const { t } = useTranslation();
  const [show, setshow] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const userdata = useSelector((state) => state?.userdata?.value?.rnuserdetails);
  const customer = useSelector(
    (state) => state?.userdata?.value?.customerprofile
  );
  console.log(customer?.Msisdn,userdata, "customercustomer")
  const toggleModal = () => {
    setshow(!show)
  }
  const toggle = () => {
    setShowModal(!showModal)
  }
  const handleRedirect = (e) => {
    try{nojoomProductViewed(data?.title)}catch{}
    e.preventDefault();
    toggleModal()
  }; 
  console.log(data, "userdata")


  const nojoomProductViewed = (_itemName) => {
    try {
      RecordlogEvents('Nojoom Product Viewed', {
        'Mobile Number': userdata?.msisdn,
        'Product Viewed': _itemName,
         Status: "Success",
        'Status Description': "Success",
        'Login Type': logintype,
      });
    } catch (e) {
    }
};
const userDetailsApi = useQuery(
  [
    GetCacheKey("GET_USER_DETAILS"),
    "customerprofile/get",
    { source: "homepage", sec: "splash" },
    {},
  ],
  {
    retry: false,
    retryOnMount: true,
  }
);

  return (
    <>
      <Link className="card_style_1 height_100" to="#" onClick={handleRedirect}>
        <div className="card_img">
          <img
            src={
              data?.imageurl ||
              process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'
            }
            alt=""
            title=""
          />
        </div>
        <div className="card_info text-center">
          <div className="card_info_grp">
          <h4 className="text-ellipsis">{data?.title}</h4>
          </div>
          <div className="card_link">
            <Link to="#" className="hyperlink">
              {data?.buttontext}
              <img
                src={
                  process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
                }
                alt=""
                title=""
              />
            </Link>
          </div>
        </div>

      </Link>
      <BottomModalRedeemUsing toggleModal={toggleModal} category={data.category_en + "|" + data.category_ar} toggle={toggle} show={show} data={customer?.Msisdn || userdata?.msisdn} />
      <GiftAnotherNumberModal toggleModal={toggle} show={showModal} data={userdata?.msisdn} category={data.category_en + "|" + data.category_ar} />
    </>
  );
};
export default ServicesCard;
